import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { getUserPlans, getUserRoles } from 'app/selectors'

const hasPermission = (userPermissions, neededPermissions) => {
  for (let perm of userPermissions) {
    if (neededPermissions.includes(perm)) {
      return true
    }
  }
  return false
}

const checkUserPermission = ({
  userRoles = [],
  userPlans = [],
  roles = [],
  plans = []
}) => {
  const authByRoles =
    roles.length === 0 ? true : hasPermission(userRoles, roles)
  const authByPlans =
    plans.length === 0 ? true : hasPermission(userPlans, plans)
  return authByPlans && authByRoles
}

class AuthByRoles extends PureComponent {
  constructor(props) {
    super(props)

    this.isAuth = props.isAuth
  }

  render() {
    const { children, notMatch = null } = this.props
    return this.isAuth ? children : notMatch
  }
}

const mapStateToProps = (state, ownProps) => ({
  isAuth: checkUserPermission({
    userRoles: getUserRoles(state),
    userPlans: getUserPlans(state),
    roles: ownProps.roles,
    plans: ownProps.plans
  })
})

AuthByRoles.propTypes = {
  isAuth: PropTypes.bool.isRequired,
  roles: PropTypes.arrayOf(PropTypes.string),
  plans: PropTypes.arrayOf(PropTypes.string), // Plans with access
  children: PropTypes.any,
  notMatch: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.element
  ])
}

export default connect(mapStateToProps)(AuthByRoles)
